// @flow
import React, { PureComponent } from 'react';
import { Image, StyleSheet, View } from 'react-native';
import { getFlag } from '../../../../resources/country-flags';

const DEFAULT_FLAG = getFlag();

export default class Flag extends PureComponent<Props> {
  render() {
    const flag = getFlag(this.props.alpha3);
    return (
      <View style={this.props.style}>
        <Image source={!!flag ? flag : DEFAULT_FLAG} style={styles.flag} resizeMode='contain' />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  flag: {
    width: 34,
    height: 26,
  },
});

type Props = {
  alpha3: string,
  style?: any,
};
